const loadTeamsSemanticTemplates = (props) => {
  const contentMediaUrl = props.contentMediaUrl ? props.contentMediaUrl : "";

  //console.log("call loadTeamsSemanticTemplates()");

  //console.log("contentMediaUrl", contentMediaUrl);

  // assets
  const T1BlueBack =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFCBQ+RqamnAAAAA1JREFUeJxjZGBgxI0AAMMAC8ggFq0AAAAASUVORK5CYII=";
  const T1BlueLight =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFWdH/cTYzNgAAAA1JREFUeJxjZGBgxI0AAMMAC8ggFq0AAAAASUVORK5CYII=";

  const easyPopIconLight = `${contentMediaUrl}/stc/templatesassets/t_a4bb4656-2e4d-4e69-a542-9145cf2dcddb.png`;

  // Note: [. in path is a request to find an object with that field key and value in the array;
  // Note: paths are always expected to end in .string
  // That is a custom path specification sytanx (could have used jsonpath and jsonpatch in alternative)
  // Note: "da_id": "dropdown", is added as a placeholder for possible dropdown
  /* eslint-disable prettier/prettier */
  const tmpSemanticTemplates = {
  "crd-1c51bc52-ea39-41cf-beba-3dfb44f84744": {
    templateId: "crd-1c51bc52-ea39-41cf-beba-3dfb44f84744",
    templateName: "Card 1A",
    tFamilyId: "fam-038da0d7-6481-4368-b1f4-a692e34929d2",
    cardJson: {
      type: "AdaptiveCard",
      $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
      version: "1.5",
      body: [
        {
          da_id: "mainImage",
          type: "Image",
          url: "",
          horizontalAlignment: "center",
          height: "180px",
        },
        {
          da_id: "title",
          type: "TextBlock",
          text: "",
          wrap: true,
          size: "Large",
          weight: "Bolder",
          color: "Default",
          horizontalAlignment: "center",
        },
        {
          da_id: "text",
          type: "TextBlock",
          text: "",
          wrap: true,
          color: "Default",
          horizontalAlignment: "Left",
        },
        {
          da_id: "dropdown",
          type: "TextBlock",
        },
        {
          da_id:"cta",
          type: "ColumnSet",
          columns: []
        }
      ],
      backgroundImage: {
        url: "",
      },
    },
    customVars: {
      actions: {
        path: "body[.type=ActionSet.actions",
      },
      dropdown: {
        path: "body[.da_id=dropdown.type",
      },
      pathSeparator: ".",
      pathFindSeparator: "[.",
    },
    userCustomizable: {
      mainImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=mainImage.url",
          },
        ],
        title: "Main image",
        description: "applied above the title",
        type: "image",
        default: null,
        allowed: true,
        required: false,
      },
      backgroundImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "backgroundImage.url",
          },
        ],
        title: "Background image",
        description: "applied as a card background",
        type: "image",
        default: null,
        allowed: true,
        required: false,
      },
      imageHeight: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=mainImage.height",
          },
        ],
        title: "Main image height",
        description: "main image height",
        type: "string",
        default: "180px",
        allowed: true,
        required: false,
      },
      imageWidth: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=mainImage.width",
          },
        ],
        title: "Main image width",
        description: "main image width",
        type: "string",
        default: null,
        allowed: true,
        required: false,
      },
      title: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.text",
          },
        ],
        title: "title",
        description: "title",
        type: "string",
      },
      titleColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.color",
          },
        ],
        title: "title color",
        description: "title color",
        type: "string",
        default: "Default",
      },
      titleSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.size",
          },
        ],
        title: "title size",
        description: "title size",
        type: "string",
        default: "Large",
      },
      text: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=text.text",
          },
        ],
        title: "text",
        description: "text",
        type: "string",
      },
      textColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=text.color",
          },
        ],
        title: "text color",
        description: "text color",
        type: "string",
        default: "Default",
      },
      textSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=text.size",
          },
        ],
        title: "text size",
        description: "text size",
        type: "string",
        default: "Default",
      },
    },
    isPublished: true, // available in selectable catalogue
    copiedFrom: "",
  },
  "crd-e9e05ff3-3e6d-48ee-b411-eeb7e7224a60": {
    templateId: "crd-e9e05ff3-3e6d-48ee-b411-eeb7e7224a60",
    templateName: "Card 1B",
    tFamilyId: "fam-038da0d7-6481-4368-b1f4-a692e34929d2",
    cardJson: {
      type: "AdaptiveCard",
      $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
      version: "1.5",
      body: [
        {
          da_id: "title",
          type: "TextBlock",
          text: "",
          wrap: true,
          size: "Large",
          weight: "Bolder",
          color: "Default",
          horizontalAlignment: "center",
        },
        {
          da_id: "mainImage",
          type: "Image",
          url: "",
          horizontalAlignment: "Center",
          height: "180px",
        },
        {
          da_id: "text",
          type: "TextBlock",
          text: "",
          wrap: true,
          color: "Default",
          horizontalAlignment: "Left",
        },
        {
          da_id: "dropdown",
          type: "TextBlock",
        },
        {
          da_id:"cta",
          type: "ColumnSet",
          columns: []
        }
      ],
      backgroundImage: {
        url: "",
      },
    },
    customVars: {
      actions: {
        path: "body[.type=ActionSet.actions",
      },
      dropdown: {
        path: "body[.da_id=dropdown.type",
      },
      pathSeparator: ".",
      pathFindSeparator: "[.",
    },
    userCustomizable: {
      // Note: currently mainImage is outside of images object
      mainImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=mainImage.url",
          },
        ],
        title: "Main image",
        description: "applied above the title",
        type: "image",
        default: null,
        allowed: true,
        required: false,
      },
      backgroundImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "backgroundImage.url",
          },
        ],
        title: "Background image",
        description: "applied as a card background",
        type: "image",
        default: null,
        allowed: true,
        required: false,
      },
      imageHeight: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=mainImage.height",
          },
        ],
        title: "Main image height",
        description: "main image height",
        type: "string",
        default: "180px",
        allowed: true,
        required: false,
      },
      imageWidth: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=mainImage.width",
          },
        ],
        title: "Main image width",
        description: "main image width",
        type: "string",
        default: null,
        allowed: true,
        required: false,
      },
      title: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.text",
          },
        ],
        title: "title",
        description: "title",
        type: "string",
      },
      titleColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.color",
          },
        ],
        title: "title color",
        description: "title color",
        type: "string",
        default: "Default",
      },
      titleSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.size",
          },
        ],
        title: "title size",
        description: "title size",
        type: "string",
        default: "Large",
      },
      text: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=text.text",
          },
        ],
        title: "text",
        description: "text",
        type: "string",
      },
      textColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=text.color",
          },
        ],
        title: "text color",
        description: "text color",
        type: "string",
        default: "Default",
      },
      textSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=text.size",
          },
        ],
        title: "text size",
        description: "text size",
        type: "string",
        default: "Default",
      },
    },
    isPublished: true, // available in selectable catalogue
    copiedFrom: "",
  },
  "crd-3c08cdb8-877a-4d62-a292-71d0fe3b1e5c": {
    templateId: "crd-3c08cdb8-877a-4d62-a292-71d0fe3b1e5c",
    templateName: "Card 2A",
    tFamilyId: "fam-038da0d7-6481-4368-b1f4-a692e34929d2",
    cardJson: {
      $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
      type: "AdaptiveCard",
      version: "1.5",
      body: [
        {
          type: "ColumnSet",
          columns: [
            {
              type: "Column",
              da_id: "c1",
              width: "stretch",
              items: [
                {
                  da_id: "title",
                  type: "TextBlock",
                  text: "",
                  weight: "Bolder",
                  size: "Large",
                  wrap: true,
                },
                {
                  da_id: "text",
                  type: "TextBlock",
                  text: "",
                  isSubtle: true,
                  spacing: "ExtraLarge",
                  wrap: true,
                },
                {
                  da_id: "dropdown",
                  type: "TextBlock",
                },
              ],
            },
            {
              type: "Column",
              da_id: "c2",
              width: "auto",
              items: [
                {
                  da_id: "mainImage",
                  type: "Image",
                  url: "",
                  horizontalAlignment: "Right",
                  size: "auto",
                  height: "180px",
                },
              ],
            },
          ],
        },
        {
          da_id:"cta",
          type: "ColumnSet",
          columns: []
        }
      ],
      backgroundImage: {
        url: "",
      },
    },
    customVars: {
      actions: {
        path: "body[.type=ActionSet.actions",
      },
      dropdown: {
        path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=dropdown.type",
      },
      pathSeparator: ".",
      pathFindSeparator: "[.",
    },
    userCustomizable: {
      // Note: currently mainImage is outside of images object
      mainImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=mainImage.url",
          },
        ],
        title: "Main image",
        description: "applied on the right column",
        type: "image",
        default: null,
        allowed: true,
        required: false,
      },
      backgroundImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "backgroundImage.url",
          },
        ],
        title: "Background image",
        description: "applied as a card background",
        type: "image",
        default: null,
        allowed: true,
        required: false,
      },
      imageHeight: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=mainImage.height",
          },
        ],
        title: "Main image height",
        description: "main image height",
        type: "string",
        default: null,
        allowed: true,
        required: false,
      },
      imageWidth: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=mainImage.width",
          },
        ],
        title: "Main image width",
        description: "main image width",
        type: "string",
        default: null,
        allowed: true,
        required: false,
      },
      title: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=title.text",
          },
        ],
        title: "title",
        description: "title",
        type: "string",
      },
      titleColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=title.color",
          },
        ],
        title: "title color",
        description: "title color",
        type: "string",
        default: "Default",
      },
      titleSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=title.size",
          },
        ],
        title: "title size",
        description: "title size",
        type: "string",
        default: "Large",
      },
      text: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=text.text",
          },
        ],
        title: "text",
        description: "text",
        type: "string",
      },
      textColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=text.color",
          },
        ],
        title: "text color",
        description: "text color",
        type: "string",
        default: "Default",
      },
      textSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=text.size",
          },
        ],
        title: "text size",
        description: "text size",
        type: "string",
        default: "Default",
      },
    },
    isPublished: true, // available in selectable catalogue
    copiedFrom: "",
  },
  "crd-ec2a2801-9b85-44fc-96ed-859ab148df49": {
    templateId: "crd-ec2a2801-9b85-44fc-96ed-859ab148df49",
    templateName: "Card 2B",
    tFamilyId: "fam-038da0d7-6481-4368-b1f4-a692e34929d2",
    cardJson: {
      $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
      type: "AdaptiveCard",
      version: "1.5",
      body: [
        {
          type: "ColumnSet",
          columns: [
            {
              da_id: "c1",
              type: "Column",
              width: "Stretch",
              items: [
                {
                  da_id: "mainImage",
                  type: "Image",
                  url: "",
                  horizontalAlignment: "Center",
                  size: "Auto",
                  height: "180px",
                },
              ],
            },
            {
              type: "Column",
              da_id: "c2",
              width: "stretch",
              items: [
                {
                  da_id: "title",
                  type: "TextBlock",
                  text: "",
                  weight: "Bolder",
                  size: "Large",
                  wrap: true,
                },
                {
                  da_id: "text",
                  type: "TextBlock",
                  text: "",
                  isSubtle: true,
                  spacing: "ExtraLarge",
                  wrap: true,
                },
                {
                  da_id: "dropdown",
                  type: "TextBlock",
                },
              ],
            },
          ],
        },
        {
          da_id:"cta",
          type: "ColumnSet",
          columns: []
        }
      ],
      backgroundImage: {
        url: "",
      },
    },
    customVars: {
      actions: {
        path: "body[.type=ActionSet.actions",
      },
      dropdown: {
        path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=dropdown.type",
      },
      pathSeparator: ".",
      pathFindSeparator: "[.",
    },
    userCustomizable: {
      // Note: currently mainImage is outside of images object
      mainImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=mainImage.url",
          },
        ],
        title: "Main image",
        description: "applied on the right column",
        type: "image",
        default: null,
        allowed: true,
        required: false,
      },
      backgroundImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "backgroundImage.url",
          },
        ],
        title: "Background image",
        description: "applied as a card background",
        type: "image",
        default: null,
        allowed: true,
        required: false,
      },
      imageHeight: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=mainImage.height",
          },
        ],
        title: "Main image height",
        description: "main image height",
        type: "string",
        default: null,
        allowed: true,
        required: false,
      },
      imageWidth: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=mainImage.width",
          },
        ],
        title: "Main image width",
        description: "main image width",
        type: "string",
        default: null,
        allowed: true,
        required: false,
      },
      title: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=title.text",
          },
        ],
        title: "title",
        description: "title",
        type: "string",
      },
      titleColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=title.color",
          },
        ],
        title: "title color",
        description: "title color",
        type: "string",
        default: "Default",
      },
      titleSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=title.size",
          },
        ],
        title: "title size",
        description: "title size",
        type: "string",
        default: "Large",
      },
      text: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=text.text",
          },
        ],
        title: "text",
        description: "text",
        type: "string",
      },
      textColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=text.color",
          },
        ],
        title: "text color",
        description: "text color",
        type: "string",
        default: "Default",
      },
      textSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=text.size",
          },
        ],
        title: "text size",
        description: "text size",
        type: "string",
        default: "Default",
      },
    },
    isPublished: true, // available in selectable catalogue
    copiedFrom: "",
  },
  "crd-1f7a5ca6-3198-42bb-bc93-e77bcd1ddbed": {
    templateId: "crd-1f7a5ca6-3198-42bb-bc93-e77bcd1ddbed",
    templateName: "Card T1",
    tFamilyId: "fam-44197fb8-7a0b-4079-a76f-25210e68db4e",
    cardJson: {
      type: "AdaptiveCard",
      $schema: "https://adaptivecards.io/schemas/adaptive-card.json",
      version: "1.5",
      body: [
        {
          type: "ColumnSet",
          columns: [
            {
              type: "Column",
              da_id: "c1",
              "width": "33",
              "items": [
                {
                  da_id: "image1",
                  type: "Image",
                  url: "",
                  horizontalAlignment: "Left",
                  size: "Auto",
                  height: "90px",
                },
              ],
            },
            {
              type: "Column",
              da_id: "c2",
              "width": "33"
            },
            {
              type: "Column",
              da_id: "c3",
              "width": "33",
              "items": [
                {
                  da_id: "image2",
                  type: "Image",
                  url: "",
                  horizontalAlignment: "Right",
                  size: "Auto",
                  height: "90px",
                }
              ],
              "horizontalAlignment": "Right"
            }
          ],
          "spacing": "None"
        },
        {
          da_id: "title",
          spacing: "Large",
          // "style": "heading",
          // size: "Large",
          // weight: "Bolder",
          text: "",
          type: "TextBlock",
          wrap: true,
        },
        {
          da_id: "text",
          "type": "TextBlock",
          "text": "",
          "wrap": true
        },
        {
          da_id: "mainImage",
          type: "Image",
          url: "",
          horizontalAlignment: "Center",
          height: "180px",
        },
        {
          "type": "Container",
          "spacing": "ExtraLarge"
        },
        {
          da_id: "dropdown",
          type: "TextBlock",
        },
        {
          type: "ActionSet",
          actions: [],
          horizontalAlignment: "left",
          spacing: "Large",
        },
      ],
      backgroundImage: {
        url: "",
        verticalAlignment: "Default",
      },
    },
    customVars: {
      actions: {
        path: "body[.type=ActionSet.actions",
      },
      dropdown: {
        path: "body[.da_id=dropdown.type",
      },
      pathSeparator: ".",
      pathFindSeparator: "[.",
    },
    userCustomizable: {
      // Note: currently mainImage is outside of images object
      mainImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=mainImage.url",
          },
        ],
        title: "Main image",
        description: "applied on the right column",
        type: "image",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },
      backgroundImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "backgroundImage.url",
          },
        ],
        title: "Background image",
        description: "applied as a card background",
        type: "image",
        default: T1BlueBack,
        allowed: true,
        required: false,
        hidden: false,
      },
      backgroundVerticalAlignment: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "backgroundImage.verticalAlignment",
          },
        ],
        title: "Background vertical alignment",
        description: "vertical alignment of the background image",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },
      imageHeight: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=mainImage.height",
          },
        ],
        title: "Main image height",
        description: "main image height",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },
      imageWidth: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=mainImage.width",
          },
        ],
        title: "Main image width",
        description: "main image width",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },

      image1: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=image1.url",
          },
        ],
        title: "Image 1",
        description: "applied on the left column",
        type: "image",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },
      image1Height: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=image1.height",
          },
        ],
        title: "Image 1 height",
        description: "image 1 height",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        overwriteField: true,
        hidden: false,
      },
      image1Width: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=image1.width",
          },
        ],
        title: "Image 1 width",
        description: "image 1 width",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        overwriteField: true,
        hidden: false,
      },

      image2: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c3.items[.da_id=image2.url",
          },
        ],
        title: "Image 2",
        description: "applied on the right column",
        type: "image",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },
      image2Height: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c3.items[.da_id=image2.height",
          },
        ],
        title: "Image 2 height",
        description: "image 2 height",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        overwriteField: true,
        hidden: false,
      },
      image2Width: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c3.items[.da_id=image2.width",
          },
        ],
        title: "Image 2 width",
        description: "image 2 width",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        overwriteField: true,
        hidden: false,
      },

      title: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.text",
          },
        ],
        title: "title",
        description: "title",
        type: "string",
        hidden: false,
      },
      titleColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.color",
          },
        ],
        title: "title color",
        description: "title color",
        type: "string",
        default: "Light",
        overwriteField: true,
        hidden: false,
      },
      titleSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.size",
          },
        ],
        title: "title size",
        description: "title size",
        type: "string",
        default: "Large",
        hidden: false,
      },
      titleWeight: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=title.weight",
          },
        ],
        title: "title weight",
        description: "title weight",
        type: "string",
        default: "Default",
        hidden: false,
      },
      text: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=text.text",
          },
        ],
        title: "text",
        description: "text",
        type: "string",
        hidden: false,
      },
      textColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=text.color",
          },
        ],
        title: "text color",
        description: "text color",
        type: "string",
        default: "Light",
        overwriteField: true,
        hidden: false,
      },
      textSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.da_id=text.size",
          },
        ],
        title: "text size",
        description: "text size",
        type: "string",
        default: "Default",
        hidden: false,
      },
      disableDropdownCTA: {
        title: "Disable dropdown CTA",
        description: "Disable dropdown CTA",
        type: "boolean",
        default: true,
        hidden: true,
      },
    },
    isPublished: true, // available in selectable catalogue
    copiedFrom: "",
  },
  "crd-9fe9a579-738c-4010-95cf-615e67dae582": {
    templateId: "crd-9fe9a579-738c-4010-95cf-615e67dae582",
    templateName: "Card F1",
    tFamilyId: "fam-44197fb8-7a0b-4079-a76f-25210e68db4e",
    cardJson: {
      $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
      type: "AdaptiveCard",
      version: "1.5",
      body: [
        {
          type: "ColumnSet",
          columns: [
            {
              da_id: "c1",
              type: "Column",
              width: "80px",
              "items": [
                {
                  da_id: "image1",
                  type: "Image",
                  url: "",
                  horizontalAlignment: "Center",
                  size: "Auto",
                  height: "78px",
                }
              ]
            },
            {
              type: "Column",
              da_id: "c2",
              width: "75",
              spacing: "Large",
              items: [
                {
                  da_id: "title",
                  type: "TextBlock",
                  text: "",
                  // weight: "Bolder",
                  // size: "Large",
                  wrap: true,
                  spacing: "Small",
                },
                {
                  da_id: "mainImage",
                  type: "Image",
                  url: "",
                  horizontalAlignment: "Center",
                  height: "180px",
                },
                {
                  da_id: "text",
                  type: "TextBlock",
                  text: "",
                  isSubtle: true,
                  spacing: "Large",
                  wrap: true,
                },
                {
                  "type": "ColumnSet",
                  "columns": [
                    {
                    "type": "Column",
                    "width": "stretch",
                    "minHeight": "20px"
                    }
                  ]
                },
                {
                  da_id: "dropdown",
                  type: "TextBlock",
                },
                {
                  type: "ActionSet",
                  actions: [],
                  horizontalAlignment: "Left",
                  spacing: "Large",
                },
              ],
            },
          ],
        },
      ],
      backgroundImage: {
        url: "",
        verticalAlignment: "Default",
      },
    },
    customVars: {
      actions: {
        path: "body[.type=ColumnSet.columns[.da_id=c2.items[.type=ActionSet.actions",
      },
      dropdown: {
        path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=dropdown.type",
      },
      pathSeparator: ".",
      pathFindSeparator: "[.",
    },
    userCustomizable: {
      // Note: currently mainImage is outside of images object
      mainImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=mainImage.url",
          },
        ],
        title: "Main image",
        description: "applied on the right column",
        type: "image",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },
      imageHeight: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=mainImage.height",
          },
        ],
        title: "Main image height",
        description: "main image height",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },
      imageWidth: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=mainImage.width",
          },
        ],
        title: "Main image width",
        description: "main image width",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },

      image1: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=image1.url",
          },
        ],
        title: "Image 1",
        description: "applied on the left column",
        type: "image",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },
      image1Height: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=image1.height",
          },
        ],
        title: "Image 1 height",
        description: "image 1 height",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        overwriteField: true,
        hidden: false,
      },
      image1Width: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c1.items[.da_id=image1.width",
          },
        ],
        title: "Image 1 width",
        description: "image 1 width",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        overwriteField: true,
        hidden: false,
      },
      backgroundImage: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "backgroundImage.url",
          },
        ],
        title: "Background image",
        description: "applied as a card background",
        type: "image",
        default: T1BlueBack,
        allowed: true,
        required: false,
        hidden: false,
      },
      backgroundVerticalAlignment: {
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "backgroundImage.verticalAlignment",
          },
        ],
        title: "Background vertical alignment",
        description: "vertical alignment of the background image",
        type: "string",
        default: null,
        allowed: true,
        required: false,
        hidden: false,
      },
      title: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=title.text",
          },
        ],
        title: "title",
        description: "title",
        type: "string",
        hidden: false,
      },
      titleColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=title.color",
          },
        ],
        title: "title color",
        description: "title color",
        type: "string",
        default: "Light",
        overwriteField: true,
        hidden: false,
      },
      titleSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=title.size",
          },
        ],
        title: "title size",
        description: "title size",
        type: "string",
        default: "Large",
        hidden: false,
      },
      titleWeight: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=title.weight",
          },
        ],
        title: "title weight",
        description: "title weight",
        type: "string",
        default: "Default",
        hidden: false,
      },
      text: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=text.text",
          },
        ],
        title: "text",
        description: "text",
        type: "string",
        hidden: false,
      },
      textColor: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=text.color",
          },
        ],
        title: "text color",
        description: "text color",
        type: "string",
        default: "Light",
        overwriteField: true,
        hidden: false,
      },
      textSize: {
        allowed: true,
        required: false,
        apply: [
          {
            changes: [{ type: "simplyapply" }],
            path: "body[.type=ColumnSet.columns[.da_id=c2.items[.da_id=text.size",
          },
        ],
        title: "text size",
        description: "text size",
        type: "string",
        default: "Default",
        hidden: false,
      },
      disableDropdownCTA: {
        title: "Disable dropdown CTA",
        description: "Disable dropdown CTA",
        type: "boolean",
        default: true,
        hidden: true,
      },
    },
    isPublished: true, // available in selectable catalogue
    copiedFrom: "",
  },
  };

  //============== Snam specific ones ==============
  /*const applyBoldTitle = (template) => {
  template.userCustomizable.titleWeight['default'] = "Bolder";
  }*/
  const applyEasyPOPImageTopRight = (template) => {
  template.userCustomizable.image2['default'] = easyPopIconLight;
  template.userCustomizable.image2Width['default'] = "72px";
  template.userCustomizable.image2Height['default'] = "67px";
  }

  const applyEasyPOPImageTopLeft = (template) => {
  template.userCustomizable.image1['default'] = easyPopIconLight;
  template.userCustomizable.image1Width['default'] = "88px";
  template.userCustomizable.image1Height['default'] = "88px";
  }

  const applySnamImageLeftColumn = (template, image) => {
  template.userCustomizable.image1['default'] = image;
  template.userCustomizable.image1Width['default'] = "88px";
  template.userCustomizable.image1Width['overwriteField'] = true;
  template.userCustomizable.image1Height['default'] = "88px";
  template.userCustomizable.image1Height['overwriteField'] = true;
  }
 
  // Snam Blu
  // crd-1f7a5ca6-3198-42bb-bc93-e77bcd1ddbed is the generic one
  const T1EasypopBlu = structuredClone(tmpSemanticTemplates["crd-1f7a5ca6-3198-42bb-bc93-e77bcd1ddbed"])
  T1EasypopBlu.templateId = "crd-70443292-2541-44df-8c3e-f4fab4dc53c2";
  T1EasypopBlu.tFamilyId = "fam-dc423757-effc-4510-ac5a-9c9f4c9ec268";
  T1EasypopBlu.templateName = "Blu";
  applyEasyPOPImageTopRight(T1EasypopBlu);
  T1EasypopBlu.userCustomizable.image1Width['default'] = "88px";
  T1EasypopBlu.userCustomizable.image1Width['overwriteField'] = true;
  T1EasypopBlu.userCustomizable.image1Height['default'] = "88px";
  T1EasypopBlu.userCustomizable.image1Height['overwriteField'] = true;
  T1EasypopBlu.userCustomizable.image2['disabled'] = true;
  T1EasypopBlu.userCustomizable.image2['hidden'] = true;
  T1EasypopBlu.userCustomizable.mainImage['disabled'] = true;
  T1EasypopBlu.userCustomizable.mainImage['hidden'] = true;
  T1EasypopBlu.userCustomizable.backgroundImage['disabled'] = true;
  T1EasypopBlu.userCustomizable.backgroundImage['hidden'] = true;
  T1EasypopBlu.userCustomizable.backgroundImage['default'] = T1BlueBack;
  T1EasypopBlu.userCustomizable.titleColor['default'] = "Light";
  T1EasypopBlu.userCustomizable.textColor['default'] = "Light";

  const T1EasypopLight = structuredClone(T1EasypopBlu);
  T1EasypopLight.templateId = "crd-7bdd0769c-b817-44eb-8bcd-ba129a5a47cc";
  T1EasypopLight.templateName = "Light";
  T1EasypopLight.userCustomizable.backgroundImage['default'] = T1BlueLight;
  T1EasypopLight.userCustomizable.titleColor['default'] = "Dark";
  T1EasypopLight.userCustomizable.textColor['default'] = "Dark";

  //applyBoldTitle(T1EasypopBlu);

  const F1Infoeasypop_dark = structuredClone(tmpSemanticTemplates["crd-9fe9a579-738c-4010-95cf-615e67dae582"])
  F1Infoeasypop_dark.templateId = "crd-48344bd1-8d43-4a6d-8c6c-e09e4ef73996";
  F1Infoeasypop_dark.tFamilyId = "fam-dc423757-effc-4510-ac5a-9c9f4c9ec268";
  F1Infoeasypop_dark.templateName = "Info_blue_easyPOP";
  applyEasyPOPImageTopLeft(F1Infoeasypop_dark);
  F1Infoeasypop_dark.userCustomizable.image1['disabled'] = true;
  F1Infoeasypop_dark.userCustomizable.image1['hidden'] = true;
  F1Infoeasypop_dark.userCustomizable.image1Width['default'] = "77.4px";
  F1Infoeasypop_dark.userCustomizable.image1Height['default'] = "67px";
  F1Infoeasypop_dark.userCustomizable.mainImage['disabled'] = true;
  F1Infoeasypop_dark.userCustomizable.mainImage['hidden'] = true;
  F1Infoeasypop_dark.userCustomizable.backgroundImage['disabled'] = true;
  F1Infoeasypop_dark.userCustomizable.backgroundImage['hidden'] = true;
  //applyBoldTitle(F1Infoeasypop_dark);

  const F1Infoeasypop_light = structuredClone(F1Infoeasypop_dark);
  F1Infoeasypop_light.templateId = "crd-c73ef69e-ec22-4fb4-91f1-4d0aff0fb3ba";
  F1Infoeasypop_light.templateName = "Info_light_easypop";
  applyEasyPOPImageTopLeft(F1Infoeasypop_light);
  F1Infoeasypop_light.userCustomizable.image1['disabled'] = true;
  F1Infoeasypop_light.userCustomizable.image1['hidden'] = true;
  F1Infoeasypop_light.userCustomizable.image1Width['default'] = "77.4px";
  F1Infoeasypop_light.userCustomizable.image1Height['default'] = "67px";
  F1Infoeasypop_light.userCustomizable.backgroundImage['default'] = T1BlueLight;
  F1Infoeasypop_light.userCustomizable.titleColor['default'] = "Dark";
  F1Infoeasypop_light.userCustomizable.textColor['default'] = "Dark";

  /*const F1Infoiconlight = structuredClone(F1Infoeasypop_dark)
  F1Infoiconlight.templateId = "crd-dbceae31-e900-4055-8aca-eb4924912eb1";
  F1Infoiconlight.tFamilyId = "fam-dc423757-effc-4510-ac5a-9c9f4c9ec268";
  F1Infoiconlight.templateName = "Info_blue_iconlight";
  applySnamImageLeftColumn(F1Infoiconlight, megaphoneIconLightBlue);
  //applyBoldTitle(F1Infoiconlight);
  */

  const F1Infoicon = structuredClone(F1Infoeasypop_dark)
  F1Infoicon.templateId = "crd-d53caadf-d6ef-4602-8296-9d0bb7c33c31";
  applySnamImageLeftColumn(F1Infoicon, "");
  F1Infoicon.tFamilyId = "fam-dc423757-effc-4510-ac5a-9c9f4c9ec268";
  F1Infoicon.templateName = "Info_blue_icon";
  F1Infoicon.userCustomizable.image1['disabled'] = false;
  F1Infoicon.userCustomizable.image1['hidden'] = false;
  //applyBoldTitle(F1Infoicon);

  const F1InfoLight = structuredClone(F1Infoicon);
  F1InfoLight.templateId = "crd-690d9038-aa79-4ee2-a6fc-7db689f17199";
  F1InfoLight.templateName = "Info_light_icon";
  F1InfoLight.userCustomizable.backgroundImage['default'] = T1BlueLight;
  F1InfoLight.userCustomizable.titleColor['default'] = "Dark";
  F1InfoLight.userCustomizable.textColor['default'] = "Dark";

  //============== Snam specific ones ==============

  // TODO:
  // [] apply titleWeight and Bolder to all of them?

  return {
    ...tmpSemanticTemplates,
    //"crd-348e4c31-6c53-4dc3-85cd-5fd7281975ce": T1gradient, // generic
    // EasyPOP specific ones
    "crd-70443292-2541-44df-8c3e-f4fab4dc53c2": T1EasypopBlu,
    "crd-7bdd0769c-b817-44eb-8bcd-ba129a5a47cc": T1EasypopLight,
    //"crd-27895d76-6f8c-4f74-aca4-0b742a074a52": T1EasypopGradient,
    "crd-48344bd1-8d43-4a6d-8c6c-e09e4ef73996": F1Infoeasypop_dark,
    "crd-c73ef69e-ec22-4fb4-91f1-4d0aff0fb3ba": F1Infoeasypop_light,
    //"crd-dbceae31-e900-4055-8aca-eb4924912eb1": F1Infoiconlight,
    "crd-d53caadf-d6ef-4602-8296-9d0bb7c33c31": F1Infoicon,
    "crd-690d9038-aa79-4ee2-a6fc-7db689f17199": F1InfoLight,
  };
};

module.exports = { loadTeamsSemanticTemplates };
